import Constants from '@/common/constants';

import IndicatorApi from '@/modules/admin/api/indicatorVisibility';

import Api from '../../../api';

const FOREIGN_TRADE_COLORS = ['#01A39D', '#787F8F', '#2F84EB', '#31BC00'];

export default {
  props: {
    countryId: {
      type: String,
      default: '',
    },
  },
  computed: {
    currentSummary() {
      return this.summary?.summary;
    },
    getForeignTradeXAxis() {
      return this.quartal ? this.categories : this.graphByYear?.years ?? [];
    },
    getForeignTradeSeries() {
      if (this.quartal) {
        return (this.series ?? []).map((seriesItem, index) => ({
          ...seriesItem,
          data: Array.isArray(seriesItem?.data) ? seriesItem.data : [],
          color: FOREIGN_TRADE_COLORS[index] ?? seriesItem.color,
        }));
      }
      if (!this.graphByYear?.data) return [];

      const foreignTradeNames = [this.isProductMode ? 'Товарооборот' : 'Оборот услуг', 'Экспорт', 'Импорт', 'Сальдо'];

      return foreignTradeNames.map((name, seriesIndex) => ({
        name,
        data: Array.isArray(this.graphByYear.data[seriesIndex]) ? this.graphByYear.data[seriesIndex] : [],
        color: FOREIGN_TRADE_COLORS[seriesIndex],
      }));
    },
    getForeignTradeValuePostfix() {
      return this.quartal ? '' : ' млн $';
    },
  },
  watch: {
    countryId() {
      this.loadYearList(true, true);
      this.clearGraph();

      if (!this.isProductMode) {
        this.loadQuartals();
      }
    },
    year() {
      if (this.year) {
        this.$emit('yearChanged', this.year);
      }
      if (this.isProductMode) return;

      this.loadQuartals();
    },
    quartal(val) {
      if (val == null) {
        this.divider = this.isProductMode ? Constants.MILLION : Constants.THOUSAND;
        this.loadData();
      } else {
        this.divider = 1;
      }
    },
    isProductMode(val) {
      if (val) {
        this.quartal = null;
      }
    },
  },
  methods: {
    loadIndicatorVisibility() {
      IndicatorApi.search().then((response) => {
        this.turnoverMoreInfo = response.data[13].moreInfoVisible;
        this.importMoreInfo = response.data[14].moreInfoVisible;
        this.exportMoreInfo = response.data[15].moreInfoVisible;
        this.exportNonEnergyMoreInfo = response.data[16].moreInfoVisible;
        this.balanceMoreInfo = response.data[17].moreInfoVisible;
      });
    },
    buildRussiaGraphByYear() {
      return {
        years: this.summary.summary.valuesByYears.map((x) => x.year),
        data: [
          this.getValuesByYears(this.indicatorValue.TOTAL_VALUE, this.divider),
          this.getValuesByYears(this.indicatorValue.EXPORT_VALUE, this.divider),
          this.getValuesByYears(this.indicatorValue.IMPORT_VALUE, this.divider),
          this.getValuesByYears(this.indicatorValue.BALANCE, this.divider),
          this.getValuesByYears(this.indicatorValue.EXPORT_NON_ENERGY_VALUE, this.divider),
        ],
      };
    },
    loadRussiaForeignTradeData(onAfterLoad) {
      this.summary = null;
      this.graphByYear = null;
      Api.getForeignTradeForOne(true, this.isProductMode, this.year, this.countryId).then((response) => {
        this.summary = response.data;
        this.graphByYear = this.buildRussiaGraphByYear();

        if (typeof onAfterLoad === 'function') {
          onAfterLoad(response);
        }

        this.$forceUpdate();
      });
    },
    loadData() {
      this.loadRussiaForeignTradeData();
    },
    switchHand(e) {
      this.isProductMode = e;
      const isQuartal = this.quartal ? 1 : Constants.THOUSAND;
      this.divider = e ? Constants.MILLION : isQuartal;
      this.loadYearList(true, true);
      this.$forceUpdate();
    },
  },
};
